// extracted by css-extract-rspack-plugin
export default {"GitHubAvatar":"User-module__GitHubAvatar__e5E1d","Link":"User-module__Link__XLNQZ"};